import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 41,
	height: 36,
	viewBox: "0 0 41 36",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M36.607 1.357H4.393a3.05 3.05 0 0 0-2.071.795c-.55.51-.858 1.2-.858 1.92v23.07c0 .72.309 1.411.858 1.92a3.05 3.05 0 0 0 2.07.795H16.25L20 35l3.387-5.143h13.22a3.05 3.05 0 0 0 2.07-.795c.55-.509.859-1.2.859-1.92V4.073c0-.72-.309-1.41-.858-1.92a3.05 3.05 0 0 0-2.07-.795Z",
		stroke: "#000",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2241%22%20height%3D%2236%22%20viewBox%3D%220%200%2041%2036%22%3E%3Cpath%20d%3D%22M36.607%201.357H4.393a3.05%203.05%200%200%200-2.071.795c-.55.51-.858%201.2-.858%201.92v23.07c0%20.72.309%201.411.858%201.92a3.05%203.05%200%200%200%202.07.795H16.25L20%2035l3.387-5.143h13.22a3.05%203.05%200%200%200%202.07-.795c.55-.509.859-1.2.859-1.92V4.073c0-.72-.309-1.41-.858-1.92a3.05%203.05%200%200%200-2.07-.795Z%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
